import type { QuestionnaireStore } from "../Store";
import type { AppStore } from "@/Modules/App/Store";
import type { Customer } from "@/Modules/Models/Domain/Customer";
import type { Questionnaire } from "@/Modules/Models/Domain/Questionnaire";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import QuestionnairesApiConnector from "@/Services/TherapyApi/Questionnaires";

import QuestionnaireSummaryTransformer from "@/Modules/Transformers/Questionaire/QuestionnaireSummary";

import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";

class SendQuestionnaireActionHandler {
  constructor(
    private readonly questionnaireStore: QuestionnaireStore,
    private readonly questionnairesApiConnector = new QuestionnairesApiConnector(),
    private readonly appStore: AppStore = useAppStore(),
    private readonly questionnaireSummaryTransformer = QuestionnaireSummaryTransformer
  ) {}

  public async handle(customer: Customer, questionnaire: Questionnaire): Promise<void> {
    this.questionnairesApiConnector
      .sendQuestionnaire(customer.id, questionnaire.id)
      .then((questionnaireSend) => {
        const quiz = this.questionnaireSummaryTransformer.toDomain(questionnaireSend);

        this.questionnaireStore.customerQuestionnaires.push(quiz);

        this.appStore.showSnackbar({
          type: NotificationType.SUCCESS,
          message: "customer.questionnaires.notification.success",
          messageParameters: {
            patient: customer.username,
            quizName: questionnaire.name,
          },
        });
      })
      .catch(danger);
  }
}
export default SendQuestionnaireActionHandler;
